import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "flex-start",
    columnGap: {
      xs: spacing(12),
      lg: spacing(16),
    },
    rowGap: {
      xs: spacing(14),
      lg: spacing(18),
    },
  },
  cell: {
    alignItems: "center",
    gap: spacing(4),
  },
  editAction: ({ isVisible }: { isVisible: boolean }) => ({
    opacity: isVisible ? 1 : 0,
    pointerEvents: isVisible ? "auto" : "none",
  }),
  createTile: {
    backgroundColor: colors.backgroundFloat,
  },
}));

export default stylesheet;
